import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Flex,
  Input,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  VStack,
} from '@chakra-ui/react';
import { DownloadIcon } from '@chakra-ui/icons';
import axiosInstance from '../../../api/AxiosInstance';

const Reportes: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [filters, setFilters] = useState<any>({
    fechaInicio: '',
    fechaFin: '',
    localidadId: '',
    programaId: '',
    tipoApoyo: '',
    beneficiarioId: '',
  });

  const handleChange = (field: string, value: any) => {
    setFilters((prev: any) => ({ ...prev, [field]: value }));
  };

  const fetchData = async () => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v) params.append(k, String(v));
    });
    const res = await axiosInstance.get(`/desarrollo-social/reportes/apoyos?${params.toString()}`);
    setData(res.data || []);
  };

  useEffect(() => { fetchData(); }, []);

  const handleExport = (format: 'excel' | 'pdf') => {
    const base = axiosInstance.defaults.baseURL || '';
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v) params.append(k, String(v));
    });
    params.append('format', format);
    window.open(`${base}/desarrollo-social/reportes/apoyos/export?${params.toString()}`, '_blank');
  };

  return (
    <VStack spacing={6} align="stretch" px={{ base: 2, md: 4 }} pt={79} pb={4}>
      <Box bg="white" p={4} borderRadius="md" boxShadow="sm">
        <Flex gap={3} flexWrap="wrap" align="center">
          <Input type="date" value={filters.fechaInicio} onChange={(e) => handleChange('fechaInicio', e.target.value)} w="170px" />
          <Input type="date" value={filters.fechaFin} onChange={(e) => handleChange('fechaFin', e.target.value)} w="170px" />
          <Input placeholder="Localidad ID" value={filters.localidadId} onChange={(e) => handleChange('localidadId', e.target.value)} w="150px" />
          <Input placeholder="Programa ID" value={filters.programaId} onChange={(e) => handleChange('programaId', e.target.value)} w="150px" />
          <Input placeholder="Tipo apoyo" value={filters.tipoApoyo} onChange={(e) => handleChange('tipoApoyo', e.target.value)} w="150px" />
          <Input placeholder="Beneficiario ID" value={filters.beneficiarioId} onChange={(e) => handleChange('beneficiarioId', e.target.value)} w="160px" />
          <Button size="sm" onClick={fetchData} variant="outline">Aplicar</Button>
          <Button size="sm" leftIcon={<DownloadIcon />} onClick={() => handleExport('excel')} variant="outline">Excel</Button>
          <Button size="sm" leftIcon={<DownloadIcon />} onClick={() => handleExport('pdf')} variant="outline">PDF</Button>
        </Flex>
      </Box>

      <Box overflowX="auto" borderRadius="md" boxShadow="md" bg="white">
        <Table size="sm">
          <Thead bg="#5b182b">
            <Tr>
              <Th color="white" fontSize="xs">Programa</Th>
              <Th color="white" fontSize="xs">Beneficiario</Th>
              <Th color="white" fontSize="xs">Tipo apoyo</Th>
              <Th color="white" fontSize="xs">Cantidad</Th>
              <Th color="white" fontSize="xs">Fecha</Th>
            </Tr>
          </Thead>
          <Tbody>
            {data.length === 0 ? (
              <Tr><Td colSpan={5} textAlign="center" py={6}><Text color="gray.400">Sin datos</Text></Td></Tr>
            ) : data.map((item) => (
              <Tr key={item.id}>
                <Td>{item.programa?.nombre || item.programaId}</Td>
                <Td>{item.beneficiario?.nombreCompleto || item.beneficiarioId}</Td>
                <Td>{item.tipoApoyo}</Td>
                <Td>{item.cantidadEntregada}</Td>
                <Td>{item.fechaEntrega ? new Date(item.fechaEntrega).toLocaleDateString('es-MX') : '-'}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>
    </VStack>
  );
};

export default Reportes;

